import { render, staticRenderFns } from "./date.vue?vue&type=template&id=9097aae6&"
import script from "./date.vue?vue&type=script&lang=js&"
export * from "./date.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9097aae6')) {
      api.createRecord('9097aae6', component.options)
    } else {
      api.reload('9097aae6', component.options)
    }
    module.hot.accept("./date.vue?vue&type=template&id=9097aae6&", function () {
      api.rerender('9097aae6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/form-templates/date.vue"
export default component.exports